import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Modal shown when a user tries to navigate away with unsaved changes.
 * Renders only when blocker.state === 'blocked'.
 *
 * @param {{ blocker: { state: string, proceed: () => void, reset: () => void } }} props
 */
export default function UnsavedChangesModal({ blocker }) {
  if (!blocker || blocker.state !== 'blocked') return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50"
      onClick={(e) => { if (e.target === e.currentTarget) blocker.reset(); }}>
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Unsaved Changes</h3>
              <p className="mt-2 text-sm text-gray-600">
                You have unsaved changes. Are you sure you want to leave? Your changes will be lost.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 bg-gray-50 border-t border-gray-200">
          <button
            onClick={() => blocker.reset()}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            Stay
          </button>
          <button
            onClick={() => blocker.proceed()}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors">
            Leave
          </button>
        </div>
      </div>
    </div>
  );
}
